import { styled } from '@mui/material/styles';
import { Box, Button, IconButton, Typography } from '@mui/material';

// 로고&직인 등록 모달 styled (Figma 5154:9221 / 5154:9416)
// 색상: Header/Tab #262626 · Card border #D9D9D9 · 라벨/등록 텍스트 #141414
//       빈 안내 #A6A6A6 · 수정 #55C982 · 삭제 #EE735A · 저장 #4AB3BC

// ============================================
// 모달 셸
// ============================================
export const ModalContainer = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '528px',
  maxWidth: 'calc(100vw - 32px)',
  maxHeight: '90vh',
  background: '#fff',
  borderRadius: '8px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  outline: 'none',
});

export const ModalHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '48px',
  padding: '0 24px',
  background: '#262626',
  flexShrink: 0,
});

export const HeaderTitle = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#fff',
});

export const CloseButton = styled(IconButton)({
  width: '24px',
  height: '24px',
  padding: 0,
  color: '#fff',
});

export const ModalContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  alignItems: 'center',
  padding: '24px',
  background: '#fafbfc',
  overflowY: 'auto',
});

// ============================================
// 직인 / 로고 탭
// ============================================
export const TabRow = styled(Box)({
  display: 'flex',
  width: '480px',
});

export const TabButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'active' && prop !== 'side',
})(({ active, side }) => ({
  flex: 1,
  minWidth: 0,
  padding: '8px 24px',
  fontSize: '16px',
  fontWeight: 500,
  letterSpacing: '-0.16px',
  boxShadow: 'none',
  textTransform: 'none',
  borderRadius: side === 'left' ? '8px 0 0 8px' : '0 8px 8px 0',
  ...(active
    ? {
        background: '#262626',
        color: '#fff',
        border: '1px solid #262626',
        '&:hover': { background: '#262626', boxShadow: 'none' },
      }
    : {
        background: '#fff',
        color: '#262626',
        border: '1px solid #262626',
        '&:hover': { background: '#fff', boxShadow: 'none' },
      }),
}));

// ============================================
// 카드 / 섹션
// ============================================
export const Card = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  // 사진 업로드 영역 등 고정폭 자식을 가운데 정렬 (제목 FieldGroup 은 width 100% 라 가로폭 유지)
  alignItems: 'center',
  width: '100%',
  padding: '16px',
  background: '#fff',
  border: '1px solid #D9D9D9',
  borderRadius: '8px',
});

export const Section = styled(Box, {
  shouldForwardProp: prop => prop !== 'gap',
})(({ gap = 12 }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: `${gap}px`,
  width: '100%',
}));

export const SectionLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#141414',
});

// 빈 목록 안내
export const EmptyBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '56px',
  padding: '12px 16px',
  background: '#fff',
  borderRadius: '4px',
});

export const EmptyText = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#A6A6A6',
  textAlign: 'center',
});

// 목록 아이템 (데이터 있을 때)
export const ItemBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  height: '56px',
  padding: '12px 16px',
  background: '#fff',
  border: '1px solid #D9D9D9',
  borderRadius: '4px',
});

export const ItemName = styled(Typography)({
  flex: 1,
  minWidth: 0,
  fontSize: '14px',
  fontWeight: 500,
  color: '#141414',
});

export const ItemActions = styled(Box)({
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
});

export const EditButton = styled(Button)({
  minWidth: 'auto',
  height: '32px',
  padding: '6px 16px',
  borderRadius: '4px',
  border: '1px solid #D9D9D9',
  background: '#fff',
  color: '#55C982',
  fontSize: '14px',
  fontWeight: 600,
  boxShadow: 'none',
  textTransform: 'none',
  '&:hover': { background: '#fff', boxShadow: 'none' },
});

export const DeleteButton = styled(Button)({
  minWidth: 'auto',
  height: '32px',
  padding: '6px 16px',
  borderRadius: '4px',
  border: '1px solid #D9D9D9',
  background: '#fff',
  color: '#EE735A',
  fontSize: '14px',
  fontWeight: 600,
  boxShadow: 'none',
  textTransform: 'none',
  '&:hover': { background: '#fff', boxShadow: 'none' },
});

// 등록(업로드) 박스
export const RegisterBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '49px 16px',
  border: '1px solid #141414',
  borderRadius: '4px',
  cursor: 'pointer',
});

export const RegisterText = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#141414',
});

// ============================================
// 푸터
// ============================================
export const FooterRow = styled(Box)({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  justifyContent: 'center',
});
